var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 5" }, props),
    React.createElement("circle", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", cx: "2.5", cy: "2.5", r: "2.3" }),
    React.createElement("circle", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", cx: "9.5", cy: "2.5", r: "2.3" }),
    React.createElement("circle", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", cx: "16.5", cy: "2.5", r: "2.3" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/More.svg